<template>
  <transition
    name="loading-fade"
    @after-leave="handleAfterLeave"
  >
    <div
      v-show="visible"
      :class="['loading-mask', {
        fullscreen: fullscreen
      }]"
    >
      <div
        :class="['loading-spinner', {
          light: light
        }]"
      >
        <div class="icon-loading-container">
          <IconLoading />
        </div>
        <p
          v-if="text"
          class="loading-text"
        >
          {{ text }}
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
import IconLoading from 'fe-vui/IconLoading'

export default {
  name: 'Loading',
  components: {
    IconLoading
  },
  data() {
    return {
      text: 'loading',
      fullscreen: false,
      visible: false,
      light: false
    }
  },
  methods: {
    handleAfterLeave() {
      this.$emit('after-leave')
    },
    setText(text) {
      this.text = text
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.loading-mask {
  position: absolute;
  z-index: 99999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  &.fullscreen {
    position: fixed;
  }
}

.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  background: rgba(51, 51, 51, 80%);
  color: #999;
  text-align: center;
  transform: translate(-50%, -50%);


  &.light {
    background: rgba(248, 248, 248, 90%);
    color: #666;
  }

  .icon-loading-container {
    position: relative;
    height: 30px;
    margin: 22px auto 11px;

    .icon-loading {
      width: 30px;
      height: 30px;
    }
  }

  .loading-text {
    font-size: 14px;
    line-height: 14px;
  }
}

.loading-fade-enter,
.loading-fade-leave-active {
  opacity: 0;
}
</style>
